import { shape, string } from "prop-types"

export const OpportunityShape = shape({
    opportunityId: string.isRequired,
    name: string.isRequired,
    code: string
})